











































































































import Vue from 'vue';
import { FFormStep, FIcon } from '@fkui/vue';
import BtMinaInkomsterContent from '@/components/BtMinaInkomsterContent.vue';
import { ValidationService } from '@fkui/logic';
import { EventBus } from '@/services/MainService/event-bus';
import DataArrayItem from './DataArrayItem';

export default Vue.extend({
    name: 'BtInkomster',
    components: {
        FFormStep,
        FIcon,
        BtMinaInkomsterContent,
    },
    props: {
        dataArray: {
            type: Object,
            default: () => {
                return [] as string[];
            },
        },
    },
    data() {
        return {
            id: 'btInkomster',
            incomeArbetsinkomstEnsamChecked: false,
            incomeUtoverEnsamChecked: false,
            incomeKapitalEnsamChecked: false,
            incomeSABeloppEnsam: '',
            incomeArbetsinkomstEnsamBelopp: '',
            incomeUtoverEnsamBelopp: '',
            incomeKapitalEnsamBelopp: '',
            incomeArbetsinkomstSamboChecked: false,
            incomeUtoverSamboChecked: false,
            incomeKapitalSamboChecked: false,
            incomeSABeloppSambo: '',
            incomeArbetsinkomstSamboBelopp: '',
            incomeUtoverSamboBelopp: '',
            incomeKapitalSamboBelopp: '',
            isSambo: false,
            kund2harSa: undefined,
        };
    },
    mounted() {
        EventBus.$on('sambo-radio', this.samboClickHandler);
    },
    methods: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        openContainer(toggleIsOpen: any): void {
            this.$emit('on-change-emit-inkomster');
            toggleIsOpen();
        },
        samboClickHandler(selection: boolean): void {
            this.isSambo = !selection;
            ValidationService.validateAllElements('btInkomster');
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onEmitEnsam(data: any) {
            this.$emit('on-change-emit-inkomster');
            this.incomeArbetsinkomstEnsamChecked = data.incomeArbetsinkomstChecked;
            this.incomeUtoverEnsamChecked = data.incomeUtoverChecked;
            this.incomeKapitalEnsamChecked = data.incomeKapitalChecked;
            this.incomeSABeloppEnsam = data.incomeSABelopp;
            this.incomeArbetsinkomstEnsamBelopp = data.incomeArbetsinkomstBelopp;
            this.incomeUtoverEnsamBelopp = data.incomeUtoverBelopp;
            this.incomeKapitalEnsamBelopp = data.incomeKapitalBelopp;
            this.onSubmit();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onEmitSambo(data: any) {
            this.$emit('on-change-emit-inkomster');
            this.incomeArbetsinkomstSamboChecked = data.incomeArbetsinkomstChecked;
            this.incomeUtoverSamboChecked = data.incomeUtoverChecked;
            this.incomeKapitalSamboChecked = data.incomeKapitalChecked;
            this.incomeSABeloppSambo = data.incomeSABelopp;
            this.incomeArbetsinkomstSamboBelopp = data.incomeArbetsinkomstBelopp;
            this.incomeUtoverSamboBelopp = data.incomeUtoverBelopp;
            this.incomeKapitalSamboBelopp = data.incomeKapitalBelopp;
            this.kund2harSa = data.kund2harSa;
            this.onSubmit();
        },
        onSubmit(): void {
            this.onSubmitStep();
            ValidationService.validateAllElements('btInkomster');
        },
        onSubmitStep() {
            const dataArray = {
                ensam: [],
                sambo: [],
            };
            dataArray.ensam = this.addEnsamData();
            if (this.isSambo) {
                dataArray.sambo = this.addSamboData();
            }
            this.$root.$emit('on-submit-emit-inkomster', dataArray, 'btInkomster');
            this.$emit('on-submit-emit-inkomster', dataArray, 'btInkomster');
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addEnsamData(): any {
            const dataArray: DataArrayItem[] = [];
            if (this.incomeSABeloppEnsam) {
                dataArray.push({
                    type: 'sjukelleraktivitetsersattningEnsam',
                    label: this.$t('btp.preliminar.berakning.inkomster.info.sjukelleraktivitetsersattning'),
                    itemId: 'btp.preliminar.berakning.inkomster.info.sjukelleraktivitetsersattning',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeSABeloppEnsam,
                });
            }
            if (this.incomeArbetsinkomstEnsamChecked) {
                dataArray.push({
                    type: 'anstallningellernaringsverksamhetEnsam',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.anstallningellernaringsverksamhet'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.anstallningellernaringsverksamhet',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeArbetsinkomstEnsamBelopp,
                });
            }

            if (this.incomeUtoverEnsamChecked) {
                dataArray.push({
                    type: 'andrainkomsterEnsam',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.andrainkomster'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.andrainkomster',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeUtoverEnsamBelopp,
                });
            }

            if (this.incomeKapitalEnsamChecked) {
                dataArray.push({
                    type: 'kapitalEnsam',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.kapital'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.kapital',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.ar'),
                    value: this.incomeKapitalEnsamBelopp,
                });
            }
            return dataArray;
        },
        // eslint-disable-next-line complexity
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addSamboData(): any {
            const dataArray: DataArrayItem[] = [];
            if (this.kund2harSa === true || this.kund2harSa === false) {
                dataArray.push({
                    type: '',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.harpartnerersattning'),
                    itemId: '',
                    inkomstTyp: '',
                    value: this.kund2harSa
                        ? this.$t('btp.preliminar.berakning.inkomster.etikett.harpartnerersattning.ja')
                        : this.$t('btp.preliminar.berakning.inkomster.etikett.harpartnerersattning.nej'),
                });
            }
            if (this.incomeSABeloppSambo) {
                dataArray.push({
                    type: 'sjukelleraktivitetsersattningSambo',
                    label: this.$t('btp.preliminar.berakning.inkomster.info.sjukelleraktivitetsersattning'),
                    itemId: 'btp.preliminar.berakning.inkomster.info.sjukelleraktivitetsersattning',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeSABeloppSambo,
                });
            } else {
                dataArray.push({
                    type: 'sjukelleraktivitetsersattningSambo',
                    label: '',
                    itemId: 'btp.preliminar.berakning.inkomster.info.sjukelleraktivitetsersattning',
                    inkomstTyp: '',
                    value: '',
                });
            }
            if (this.incomeArbetsinkomstSamboChecked) {
                dataArray.push({
                    type: 'anstallningellernaringsverksamhetSambo',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.anstallningellernaringsverksamhet'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.anstallningellernaringsverksamhet',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeArbetsinkomstSamboBelopp,
                });
            }

            if (this.incomeUtoverSamboChecked) {
                dataArray.push({
                    type: 'andrainkomsterSambo',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.andrainkomster'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.andrainkomster',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.manad'),
                    value: this.incomeUtoverSamboBelopp,
                });
            }

            if (this.incomeKapitalSamboChecked) {
                dataArray.push({
                    type: 'kapitalSambo',
                    label: this.$t('btp.preliminar.berakning.inkomster.etikett.kapital'),
                    itemId: 'btp.preliminar.berakning.inkomster.etikett.kapital',
                    inkomstTyp: this.$t('btp.preliminar.berakning.inkomster.etikett.belopp.ar'),
                    value: this.incomeKapitalSamboBelopp,
                });
            }
            return dataArray;
        },
    },
});
